export const SALUTATION_MR = 'customer.salutation.mr'
export const SALUTATION_MRS = 'customer.salutation.mrs'
